import * as React from 'react';
import { MobileQuickMenuWrapper } from './MobileQuickMenu.styles';
import AlertModalWrapper from 'search/AlertPanel/AlertModalWrapper';

export type MobileQuickMenuProps = {
    carouselShown?: boolean;
    className?: string;
    LeftButton: React.ReactNode;
    RightButton: React.ReactNode;
};

export const MobileQuickMenu: React.FC<MobileQuickMenuProps> = ({
    carouselShown = false,
    className,
    LeftButton,
    RightButton
}) => (
    <MobileQuickMenuWrapper
        carouselShown={carouselShown}
        data-testid="mobile-quick-menu"
        className={className}
    >
        <AlertModalWrapper>
            {LeftButton}
            {RightButton}
        </AlertModalWrapper>
    </MobileQuickMenuWrapper>
);
